import React, { createContext, useContext, ReactNode } from 'react';
import { IModuleDTO } from '@common-frontend-submodule/interfaces/module/imodule.interface';
import { IApiResponseGenericDTO } from '@common-frontend-submodule/interfaces/common/iapi-response.interface';
import { ModuleRoutes } from '@common-frontend-submodule/enums/routes/module-routes.enum';
import ApiClient from '../../lib/api-client';

interface ModuleContextProps {
  all: () => Promise<IApiResponseGenericDTO<IModuleDTO[]>>;
  modules: () => Promise<IApiResponseGenericDTO<IModuleDTO[]>>;
  details: () => Promise<IApiResponseGenericDTO<IModuleDTO[]>>;
}

const apiClient = ApiClient.getInstance()

const ModuleContext = createContext<ModuleContextProps | undefined>(undefined);

export const ModuleProvider: React.FC<{ children: ReactNode }> = ({ children }) => {

  const all = async (): Promise<IApiResponseGenericDTO<IModuleDTO[]>> => {
    return await apiClient.getRequest<IModuleDTO[]>(`${ModuleRoutes.BasePrefix}/${ModuleRoutes.All}`);
  };

  const modules = async (): Promise<IApiResponseGenericDTO<IModuleDTO[]>> => {
    return await apiClient.getRequest<IModuleDTO[]>(`${ModuleRoutes.BasePrefix}/${ModuleRoutes.Modules}`);
  };

  const details = async (): Promise<IApiResponseGenericDTO<IModuleDTO[]>> => {
    return await apiClient.getRequest<IModuleDTO[]>(`${ModuleRoutes.BasePrefix}/${ModuleRoutes.Details}`);
  };

  return (
    <ModuleContext.Provider value={{ all, modules, details }}>
      {children}
    </ModuleContext.Provider>
  );
};

export const useModuleStore = (): ModuleContextProps => {
  const context = useContext(ModuleContext);
  if (!context) {
    throw new Error('useModuleStore must be used within a ModuleProvider');
  }
  return context;
};
